<template>
  <div class="modal fade" id="takeawayCustomerModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Customer Information</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="customerName">Customer Name *</label>
            <input 
              type="text" 
              class="form-control" 
              id="customerName" 
              v-model="customerName" 
              placeholder="Enter customer name"
              required
            />
          </div>
          <div class="form-group">
            <label for="customerPhone">Phone Number (Optional)</label>
            <input 
              type="tel" 
              class="form-control" 
              id="customerPhone" 
              v-model="customerPhone" 
              placeholder="Enter phone number"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button 
            type="button" 
            class="btn btn-primary" 
            @click="submitCustomerInfo"
            :disabled="!customerName.trim()"
          >
            Confirm Order
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';

export default {
  name: 'TakeawayCustomerPopup',
  data() {
    return {
      customerName: '',
      customerPhone: ''
    };
  },
  methods: {
    show() {
      $('#takeawayCustomerModal').modal('show');
    },
    hide() {
      $('#takeawayCustomerModal').modal('hide');
    },
    reset() {
      this.customerName = '';
      this.customerPhone = '';
    },
    submitCustomerInfo() {
      if (!this.customerName.trim()) {
        this.$toast.error('Please enter customer name');
        return;
      }
      
      this.$emit('submit', {
        customerName: this.customerName.trim(),
        customerPhone: this.customerPhone.trim()
      });
      this.hide();
      this.reset();
    }
  }
};
</script>

<style scoped>
.modal-content {
  border-radius: 10px;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  color: #333;
  font-weight: 600;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 5px;
  padding: 8px 12px;
}

.form-control:focus {
  border-color: #E3655B;
  box-shadow: 0 0 0 0.2rem rgba(227, 101, 91, 0.25);
}

.btn-primary {
  background-color: #E3655B;
  border-color: #E3655B;
}

.btn-primary:hover {
  background-color: #d45a50;
  border-color: #d45a50;
}

.btn-primary:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
}
</style>